import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";

import Config from "../Config";

//if (process.env.NODE_ENV === "development") {
//  firebase.firestore.setLogLevel("debug");
//}

// NOTE: When you add anything here, make sure to add any relevant corresponding
// code into src/util/__mocks__/firebase.ts also.

const firebaseApp = firebase.initializeApp(Config.firebase);

const firebaseAnalytics = firebase.analytics();

const firebaseAuth = firebase.auth();

const firestore = firebase.firestore();

export default firebase;
export { firebaseApp, firebaseAnalytics, firebaseAuth, firestore };
